export default __webpack_public_path__ + "media/Kruti-Dev-501-Bold.24756b12.ttf";